import { render, staticRenderFns } from "./CategoryHeaderArticles.vue?vue&type=template&id=149c8c0e&scoped=true"
import script from "./CategoryHeaderArticles.vue?vue&type=script&lang=js"
export * from "./CategoryHeaderArticles.vue?vue&type=script&lang=js"
import style0 from "./CategoryHeaderArticles.vue?vue&type=style&index=0&id=149c8c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149c8c0e",
  null
  
)

export default component.exports